import { render, staticRenderFns } from "./MirrorRecord.vue?vue&type=template&id=9971bae8&scoped=true"
import script from "./MirrorRecord.vue?vue&type=script&lang=js"
export * from "./MirrorRecord.vue?vue&type=script&lang=js"
import style0 from "./MirrorRecord.vue?vue&type=style&index=0&id=9971bae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9971bae8",
  null
  
)

export default component.exports